import { useEffect, useState } from 'react'

// https://chatgpt.com/c/680290d3-7444-8000-ad91-0381557f541a

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)

    if (media.matches !== matches) {
      setMatches(media.matches)
    }

    const listener = () => setMatches(media.matches)

    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }, [
    query,
    matches,
  ])

  return matches
}

export default useMediaQuery
